import React from "react";
import {d4ChangeAuctionStatus, d4GetMyBids, d4UpdateBid} from "../commons/api/D4Api";
import EiaButton from "../components/EiaButton";
import {findByKeyValue} from "../commons/Utils/ArrayUtils";
import TradeDialog from "../components/dialogs/TradeDialog";
import ShowDetailsButton from "../components/ShowDetailsButton";
import SelectBidderDialog from "../components/dialogs/SelectBidderDialog";
import {bidsForMyAuction} from "../commons/Converter";
import EiaAuctionsWithButtons from "../components/EiaAuctionsWithButtons";
import Utils from "../commons/Utils/Utils";
import EiaShareButton from "../components/EiaShareButton";
import {SEARCH} from "../commons/enums/Navigation";
import {useAuthenticator} from "@aws-amplify/ui-react";
import * as ApiUtils from "../commons/api/ApiUtils";
import {useCookies} from "react-cookie";
import {GAMES, getMySalesTableHeaders} from "../commons/enums/EiaEnums";
import EditAuctionDialog from "../components/dialogs/EditAuctionDialog";
import {MODES, PLATFORMS, REALM, REGIONS} from "../commons/enums/D4Enums";

const tableInitialState = {
    sorting: {
        sortModel: [{field: 'creationDate', sort: 'desc'}],
    },
}

const baseUrl = window.location.origin;

const MySalesPage = function (props) {
    const {mySalesState} = props;

    const {user} = useAuthenticator((context) => [context.user]);
    const [cookies, setCookies, removeCookies] = useCookies(['game', 'mode', 'realm', 'region', 'platform']);

    const cookiesWrapper = {
        game: cookies.game ? cookies.game : GAMES[0],
        mode: cookies.mode ? cookies.mode : MODES[0],
        realm: cookies.realm ? cookies.realm : REALM[0],
        region: cookies.region ? cookies.region : REGIONS[0],
        platform: cookies.platform ? cookies.platform : PLATFORMS[0]
    }

    const game = cookiesWrapper.game;

    const [isLoading, setIsLoading] = React.useState(false);
    const [alert, setAlert] = React.useState(null)

    const tableData = mySalesState.auctions;

    //selectedAuctionId is an array because we get it from a table and there could be more selected elements ( but we only use 1)
    const [selectedAuctionId, setSelectedAuctionId] = React.useState([])

    const [openTradeDialog, setOpenTradeDialog] = React.useState(false);
    const [openEditDialog, setOpenEditDialog] = React.useState(false);
    const [openSelectBidderDialog, setOpenSelectBidderDialog] = React.useState(false);
    const [openAuctionSpecificDialog, setOpenAuctionSpecificDialog] = React.useState(false);

    const reloadMySales = function (keepAlert) {
        if (keepAlert) {
            mySalesState.reload(setIsLoading, Utils.doNothing);
        } else {
            mySalesState.reload(setIsLoading, setAlert);
        }

    }

    React.useEffect(() => {
        setOpenTradeDialog(false);
        reloadMySales();
    }, []);

    const selectedAuction = selectedAuctionId.length === 0 ? null : findByKeyValue(tableData, "id", selectedAuctionId);

    const abort = function () {
        setIsLoading(true)

        const request = ApiUtils.getGameRequest(selectedAuction);
        request.id = selectedAuctionId[0];
        request.status = "ABORTED";

        d4ChangeAuctionStatus(request, function (response) {
            //TODO depreacted: ab nächstem release werden alle responses itemname zurückgeben
            const itemName = response.itemName ? response.itemName : response.auction.item.name;
            setAlert(["success", "Successfully aborted auction for item " + itemName]);
            reloadMySales(true);
            setIsLoading(false);
        }, function (error) {
            setAlert(["error", error.message]);
            reloadMySales(true);
            setIsLoading(false);
        })
    }

    const reactivate = function () {
        if (!selectedAuction) {
            setAlert(["error", ("Cannot find selected auction with id " + selectedAuctionId)])
            return;
        }

        setIsLoading(true)

        const request = ApiUtils.getGameRequest(selectedAuction);
        request.id = selectedAuctionId[0];
        request.status = "ACTIVE";

        d4ChangeAuctionStatus(request, function (response) {
            //TODO depreacted: ab nächstem release werden alle responses itemname zurückgeben
            const itemName = response.itemName ? response.itemName : response.auction.item.name;
            setAlert(["success", ("Successfully reactivated auction with item " + itemName)]);
            reloadMySales(true);
            setIsLoading(false);
        }, function (error) {
            setAlert(["error", error.message]);
            reloadMySales(true);
            setIsLoading(false);
        })
    }

    const edit = function () {
        if (selectedAuction.bidders.length > 0) {
            setAlert(["error", "Cannot edit '" + selectedAuction.itemName + "' since there is at least one bidder"]);
            return;
        }

        setOpenEditDialog(true)
    }

    const closeEditDialog = function (refresh) {
        setOpenEditDialog(false);
        if (refresh) {
            reloadMySales();
        }
    }

    const [bids, setBids] = React.useState([]);
    const [auctionForBids, setAuctionForBids] = React.useState({});

    const reloadBidsInSelectBidderDialog = function (auctionId) {
        if (auctionId == null) {
            auctionId = selectedAuctionId[0];
        }

        if (auctionId == null) {
            setAlert(["error", "Cannot reload bids because no auction is selected"]);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setAuctionForBids(selectedAuction);

        const request = ApiUtils.getGameRequest(selectedAuction);
        request.auctionId = auctionId;

        //we get bids for my auction here - i need a new api method with better name
        d4GetMyBids(request, function (response) {
            if (response.bids) {
                let tempBids = bidsForMyAuction(response.bids, setAlert)
                setBids(tempBids)
            } else {
                setBids([])
            }
            setIsLoading(false)
        }, function (error) {
            setAlert(["error", error.message]);
            setIsLoading(false)
        })
    }

    const accept = function (bid) {
        setIsLoading(true)

        const request = ApiUtils.getGameRequest(bid);
        request.id = bid.auctionId;
        request.status = "TRADE";
        request.buyer = bid.bidder;

        d4ChangeAuctionStatus(request, function (response) {
            reloadMySales();
            // reloadBidsInSelectBidderDialog(auctionId);
        }, function (error) {
            setAlert(["error", error.message]);
            reloadMySales(true);
            // reloadBidsInSelectBidderDialog(auctionId);
        })
    }

    const reject = function (bid, updateBidReasonEnum) {
        setIsLoading(true)

        const request = ApiUtils.getGameRequest(bid);
        request.auctionId = bid.auctionId;
        request.status = "WITHDRAWN";
        request.reasonEnum = updateBidReasonEnum;
        request.bidder = bid.bidder;

        d4UpdateBid(request, function (response) {
            reloadBidsInSelectBidderDialog(bid.auctionId);
        }, function (error) {
            setAlert(["error", error.message]);
            reloadBidsInSelectBidderDialog(bid.auctionId);
        })
    }

    const auctionSpecificButtons = [
        <ShowDetailsButton key={"detailsButton"} isFullWidth disabled={isLoading || selectedAuctionId.length === 0} title={"Details"} details={selectedAuction}
                           additionalOnClose={() => setOpenAuctionSpecificDialog(false)}/>,
        <EiaButton key={"editButton"} isFullWidth onClick={() => {
            setOpenAuctionSpecificDialog(false)
            edit()
        }} disabled={isLoading || selectedAuctionId.length === 0} tooltip={"Edit the item, currency or price of your sale"}>Edit ...</EiaButton>,
        <EiaButton key={"abortButton"} isFullWidth colorTheme={"error"} onClick={() => {
            setOpenAuctionSpecificDialog(false)
            abort()
        }} disabled={isLoading || selectedAuctionId.length === 0} tooltip={"Abort your sale"}>Abort</EiaButton>,
        <EiaButton key={"bidsButton"} isFullWidth onClick={() => {
            setOpenAuctionSpecificDialog(false);
            setOpenSelectBidderDialog(true);
            reloadBidsInSelectBidderDialog();
        }
        }
                   colorTheme={selectedAuction && selectedAuction.status === "ACTIVE" ? "success" : null}
                   disabled={isLoading || !selectedAuction || selectedAuction.bidders.length === 0}
                   tooltip={"Accept or reject bidders for your sales"}>Bids ...</EiaButton>,
        <EiaButton key={"reactivateButton"} isFullWidth onClick={() => {
            setOpenAuctionSpecificDialog(false)
            reactivate()
        }}
                   disabled={isLoading || !selectedAuction || selectedAuction.status !== "EXPIRED"} tooltip={"Reactivate sales with status EXPIRED"}>Reactivate</EiaButton>,

        <EiaButton key={"tradeButton"} isFullWidth colorTheme={"success"} onClick={() => {
            setOpenAuctionSpecificDialog(false)
            setOpenTradeDialog(true)
        }}
                   disabled={isLoading || !selectedAuction || selectedAuction.status !== "TRADE"} tooltip={"Trade sales with status TRADE"}>Trade ...</EiaButton>
    ]

    const generalButtons = [
        <EiaButton key={"reloadButton"} isFullWidth onClick={reloadMySales} disabled={isLoading} tooltip={"Reloads the item data"}>Reload</EiaButton>
    ]

    const closeSelectBiddersDialog = function (reloadAuctions) {
        setOpenSelectBidderDialog(false);
        if (reloadAuctions) {
            reloadMySales();
        }
    }

    const sellerUsernameForLink = user && user.username ? encodeURIComponent(user.username) : "";
    const overItemsRightElements = [
        <EiaShareButton key={"share-link"} title={"Share your sales"}
                        link={baseUrl + "/" + SEARCH + "?seller=" + sellerUsernameForLink}
        />
    ]

    return (
        <div>
            <SelectBidderDialog open={openSelectBidderDialog}
                                onClose={closeSelectBiddersDialog}
                                accept={accept}
                                reject={reject}
                                bids={bids}
                                auction={auctionForBids}
            />
            <TradeDialog open={openTradeDialog}
                         isSeller={true}
                         onCancel={() => setOpenTradeDialog(false)}
                         auction={selectedAuction ? selectedAuction : null}
                         salesState={mySalesState}
            />
            <EditAuctionDialog open={openEditDialog} onClose={closeEditDialog} auction={selectedAuction} game={game}/>
            <EiaAuctionsWithButtons
                alert={alert}
                isLoading={isLoading}
                tableData={tableData}
                tableHeaders={getMySalesTableHeaders(game)}
                tableInitialState={tableInitialState}
                generalButtons={generalButtons}
                auctionSpecificButtons={auctionSpecificButtons}
                selectedAuctionId={selectedAuctionId}
                selectedAuction={selectedAuction}
                setSelectedAuctionId={setSelectedAuctionId}
                openAuctionSpecificDialog={openAuctionSpecificDialog}
                setOpenAuctionSpecificDialog={setOpenAuctionSpecificDialog}
                isViewFromSeller={true}
                overItemsRightElements={overItemsRightElements}
            />
        </div>
    )
}
export default MySalesPage;